import { render, staticRenderFns } from "./LargeHeadline.vue?vue&type=template&id=3bf64169&"
import script from "./LargeHeadline.vue?vue&type=script&lang=js&"
export * from "./LargeHeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports